import { Helmet } from 'react-helmet';

const OPTIMIZELY_ENABLED = process.env.REACT_APP_OPTIMIZELY_ENABLED === 'true';

const Optimizely = () => {
    if (!OPTIMIZELY_ENABLED) {
        return null;
    }

    return (
        <Helmet>
            <script src="https://cdn.optimizely.com/js/4681871666184192.js" />
        </Helmet>
    );
};

export default Optimizely;
